module.exports = __webpack_public_path__ + "img/umbrella_add.04a0b137.svg";